import { showToast } from '@finn-auto/design-system/atoms/toast';
import * as api from '../../services/taOutreachApi';
import type { OutreachCandidate } from '../../types/taOutreach';

/**
 * After Accept on the shortlist (Sofia, Nov 2 2026): the proxy queued everyone whose profile is
 * read (`acceptMany`), and Write & send drafts them by itself (`useAutoDraft`) — nothing waits for
 * a draft. Only people without profile text need the extension: read one after another in the
 * background, then left to the auto-draft (with a brief; queueing here too would race it) or
 * queued (without one, as before).
 */
export function readAcceptedInBackground(
  accepted: OutreachCandidate[],
  {
    captureOk,
    captureOne,
    hasBrief,
    onUpdated,
  }: {
    captureOk: boolean;
    captureOne: (c: OutreachCandidate) => Promise<OutreachCandidate | null>;
    hasBrief: boolean;
    onUpdated: (item: OutreachCandidate) => void;
  }
) {
  const unread = accepted.filter((c) => c.status === 'imported' && !`${c.profileText || ''}`.trim());
  if (!unread.length) return;
  const error = (description: string) => showToast({ status: 'error', position: 'bottomCenter', description });
  void (async () => {
    for (const item of unread) {
      if (!captureOk) {
        error(`${item.name}: the FINN Outreach Sender is needed to read the profile. Install it, then accept again.`);
        continue;
      }
      const c = await captureOne(item);
      if (!c || hasBrief || c.status === 'queued') continue;
      try {
        onUpdated((await api.moveOutreach(c.id, 'queue')).item);
      } catch (err) {
        error(err instanceof Error ? err.message : 'Could not add to outreach.');
      }
    }
  })();
}
